import type {ReactAction} from '@netx/core/bootstrap';
import {dispatcher} from '@netx/core-next/instance/dispatcher';
import {faMinusCircle} from '@fortawesome/pro-solid-svg-icons';
import {type IAsset} from '@netx/core-asset-next/schema';
import {canRemoveAssetFromSavedCart} from '../enablers';
import {CART_SAVED_ACTION_LABELS} from '../locales';
import {type ISavedCart} from '../schema';
import {CART_SAVED_EVENT} from './constants';

export const cartSavedActionRemoveAssetIcon = faMinusCircle;

/**
 * Remove asset from saved cart
 * @param params
 * @returns Action
 */
export const cartSavedActionRemoveAsset = (
	savedCart?: ISavedCart,
	asset?: IAsset,
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'cart-saved-remove-asset',
	cb: () => dispatcher.trigger(CART_SAVED_EVENT.REMOVE_ASSET, savedCart, asset),
	enableTest: () => canRemoveAssetFromSavedCart(savedCart),
	icon: cartSavedActionRemoveAssetIcon,
	get label() {
		return CART_SAVED_ACTION_LABELS.REMOVE_ASSET;
	},
	...params,
});

export default cartSavedActionRemoveAsset;
